/**
 * Brand CDN image shown for a meal the user creates from scratch (custom meal, quick meal) until
 * they upload their own photo. Kept per brand because every brand serves assets from its own space.
 */
export const getTrackerMealPlaceholderImage = (appBrand: string | undefined): string => {
  switch (appBrand) {
    case 'radiance':
      return 'https://radiance.sfo2.cdn.digitaloceanspaces.com/tracker/tracker_meal.placeholder.jpg';
    case 'resilient':
      return 'https://resilient.sfo2.cdn.digitaloceanspaces.com/tracker/tracker_meal.placeholder.jpg';
    case 'shestrong':
      return 'https://shestrong.sfo2.cdn.digitaloceanspaces.com/tracker/tracker_meal.placeholder.jpg';
    case 'raize':
      return 'https://raize.sfo2.cdn.digitaloceanspaces.com/tracker/tracker_meal.placeholder.jpg';
    case 'oxy':
      return 'https://oxy.fra1.cdn.digitaloceanspaces.com/tracker/tracker_meal.placeholder.jpg';
    case 'hashimoto':
      return 'https://hashimoto.fra1.cdn.digitaloceanspaces.com/tracker/tracker_meal.placeholder.jpg';
    case 'maxx':
      return 'https://maxxnation.fra1.cdn.digitaloceanspaces.com/tracker/tracker_meal.placeholder.jpg';
    case 'dtba':
    default:
      return 'https://fra1.digitaloceanspaces.com/dl-space/tracker/tracker_meal.placeholder.jpg';
  }
};
